import { Loader } from '@googlemaps/js-api-loader';

let googleMapLoader = new Loader({
  apiKey: window.contact_script_data.google_maps_api_key,
  version: 'weekly'
}).load().then(() => {
  let coordinates = {
    lat: parseFloat(window.contact_script_data.google_maps_latitude),
    lng: parseFloat(window.contact_script_data.google_maps_longitude)
  };

  let map = new google.maps.Map(document.getElementById('map'), {
    center: coordinates,
    zoom: 14,
    disableDefaultUI: true,
    styles: [
      {
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#ebe3cd'
          }
        ]
      },
      {
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#523735'
          }
        ]
      },
      {
        'elementType': 'labels.text.stroke',
        'stylers': [
          {
            'color': '#f5f1e6'
          }
        ]
      },
      {
        'featureType': 'administrative',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#c9b2a6'
          }
        ]
      },
      {
        'featureType': 'administrative.land_parcel',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#dcd2be'
          }
        ]
      },
      {
        'featureType': 'administrative.land_parcel',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#ae9e90'
          }
        ]
      },
      {
        'featureType': 'landscape.natural',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#dfd2ae'
          }
        ]
      },
      {
        'featureType': 'poi',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#dfd2ae'
          }
        ]
      },
      {
        'featureType': 'poi',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#93817c'
          }
        ]
      },
      {
        'featureType': 'poi.park',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#a5b076'
          }
        ]
      },
      {
        'featureType': 'poi.park',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#447530'
          }
        ]
      },
      {
        'featureType': 'road',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#f5f1e6'
          }
        ]
      },
      {
        'featureType': 'road.arterial',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#fdfcf8'
          }
        ]
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#f8c967'
          }
        ]
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#e9bc62'
          }
        ]
      },
      {
        'featureType': 'road.highway.controlled_access',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#e98d58'
          }
        ]
      },
      {
        'featureType': 'road.highway.controlled_access',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#db8555'
          }
        ]
      },
      {
        'featureType': 'road.local',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#806b63'
          }
        ]
      },
      {
        'featureType': 'transit.line',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#dfd2ae'
          }
        ]
      },
      {
        'featureType': 'transit.line',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#8f7d77'
          }
        ]
      },
      {
        'featureType': 'transit.line',
        'elementType': 'labels.text.stroke',
        'stylers': [
          {
            'color': '#ebe3cd'
          }
        ]
      },
      {
        'featureType': 'transit.station',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#dfd2ae'
          }
        ]
      },
      {
        'featureType': 'water',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#b9d3c2'
          }
        ]
      },
      {
        'featureType': 'water',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#92998d'
          }
        ]
      }
    ]
  });

  new google.maps.Marker({
    position: coordinates,
    map,
  });
});

import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import ContactForm from './components/ContactForm';
import VueI18n from 'vue-i18n';

Vue.use(VueSweetalert2);

let vue_recaptcha_options = {
  siteKey: window.contact_script_data.google_recaptcha_site_key,
  loaderOptions: {
    autoHideBadge: true,
    // explicitRenderParameters: {
    //   badge: 'bottomleft',
    //   size: 'invisible',
    // }
  }
};

Vue.use(VueReCaptcha, vue_recaptcha_options);

Vue.use(VueI18n);

const messages = {
  'en_NZ': {
    message: {
      contact_error_1: window.contact_script_data.contact_error_1,
      contact_error_2: window.contact_script_data.contact_error_2,
      contact_error_3: window.contact_script_data.contact_error_3,
      contact_error_4: window.contact_script_data.contact_error_4,
    }
  },
  'zh_CN': {
    message: {
      contact_error_1: window.contact_script_data.contact_error_1,
      contact_error_2: window.contact_script_data.contact_error_2,
      contact_error_3: window.contact_script_data.contact_error_3,
      contact_error_4: window.contact_script_data.contact_error_4,
    }
  }
};

const i18n = new VueI18n({
  locale: window.contact_script_data.locale,
  messages,
});

new Vue({
  el: '#contact',
  render: h => h(ContactForm),
  i18n,
});

i18n.locale = window.contact_script_data.locale;
